var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9d115996394fb10f35d5a80e90d994e70157b481"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sipjoy-web-react@sipjoy"]={id:"9d115996394fb10f35d5a80e90d994e70157b481"};
      